import { Component, OnInit } from '@angular/core';
import { ISpecificBrickSettingsComponent } from '../../../../dashboard/brick-settings/brick-specific-type-settings/ISpecificBrickSettingsComponent';
import { Observable } from 'rxjs';
import { Select, Store } from '@ngxs/store';
import { AgentListSettingState } from '../../../../../store/dashboard/brick-wall/brick-settings/specific-brick-settings/agent-list-setting/agent-list-setting.state';
import {
   ChangeGroupsForAgentList,
   ChangeShowOwnAgent,
} from '../../../../../store/dashboard/brick-wall/brick-settings/specific-brick-settings/agent-list-setting/agent-list-setting.actions';
import { UserGroupsState } from '../../../../../store/samwin/user-groups/user-groups.state';
import { AvailableUserGroupRemoteDto } from 'src/generated/signalR/available-user-group-remote-dto';
import { map } from 'rxjs/operators';

@Component({
   selector: 'samweb-agent-list-settings',
   templateUrl: './agent-list-settings.component.html',
   styleUrls: ['./agent-list-settings.component.scss'],
})
export class AgentListSettingsComponent implements OnInit, ISpecificBrickSettingsComponent {
   public brickInstanceId: string;
   public showOwnAgent$: Observable<boolean>;

   @Select(UserGroupsState.getAvailableUserGroups)
   public availableUserGroups$: Observable<AvailableUserGroupRemoteDto[]>;

   public groupIdsForAgentList$: Observable<Array<number>>;

   constructor(private store: Store) {}

   ngOnInit() {
      this.showOwnAgent$ = this.store.select(AgentListSettingState.getIsShowOwnAgentEnabled).pipe(map((fn) => fn(this.brickInstanceId)));
      this.groupIdsForAgentList$ = this.store.select(AgentListSettingState.getGroupIdsForAgentList).pipe(map((fn) => fn(this.brickInstanceId)));
   }

   changeShowOwnAgent(showOwnAgent: boolean) {
      this.store.dispatch(new ChangeShowOwnAgent(this.brickInstanceId, showOwnAgent));
   }

   groupIdsForAgentListChanged(groupIds: number[]) {
      this.store.dispatch(new ChangeGroupsForAgentList(this.brickInstanceId, groupIds));
   }
}
